export const questions = [
  {
    id: 1,
    category: 'lifestyle',
    questionText: 'What is a common side effect for men using "gym-performance" anabolic steroids without a prescription?',
    type: 'multi',
    answers: ['A) Permanent shrinkage of the testicles', 'B) Development of breast tissue (gynaecomastia)', 'C) Complete shutdown of natural testoterone production', 'D) All of the above.'],
    correctAnswer: 3,
    educationText: 'When you take synthetic testosterone (steroids), the brain thinks the body has plenty and tells the testicles to stop producing it naturally. This leads to infertility and "shrinkage." Once a man stops taking them, it can take months or even years for his natural system to restart—if it ever does.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 2,
    category: 'lifestyle',
    questionText: 'Most men in the UK only eat about 18g of fibre a day. What is the recommended daily target to help prevent bowel cancer and heart disease?',
    type: 'multi',
    answers: ['A) 20g', 'B) 25g', 'C) 30g', 'D) 50g'],
    correctAnswer: 2,
    educationText: 'High-fibre diets (found in oats, beans, and whole grains) act like a "sweep" for the digestive system. For men, hitting the 30g target is crucial because it significantly lowers the risk of bowel cancer, which is the third most common cancer in UK men.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 3,
    category: 'lifestyle',
    questionText: 'To stay healthy and reduce the risk of heart disease and stroke, the UK Chief Medical Officers recommend that men should aim for at least how many minutes of moderate-intensity activity per week?',
    type: 'multi',
    answers: ['A) 60 minutes', 'B) 150 minutes', 'C) 300 minutes', 'D) 500 minutes'],
    correctAnswer: 1,
    educationText: '"Moderate intensity" means you are moving fast enough to raise your heart rate and breathe harder, but you can still hold a conversation. The NHS guidelines suggest this can be broken down into 30 minutes, five days a week. For men, meeting this target reduces the risk of type 2 diabetes by 40%.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 4,
    category: 'lifestyle',
    questionText: 'On average, how many years of life does being clinically obese (BMI over 30) deprive an individual of in the UK?',
    type: 'multi',
    answers: ['A) 1 -2 years', 'B) 3 - 5 years', 'C) 9 years', 'D) 15 years'],
    correctAnswer: 2,
    educationText: 'According to GOV.UK, obesity deprives an individual of an extra 9 years of life on average, often preventing people from reaching retirement age. For those with severe obesity (BMI over 40), longevity can be reduced by as much as 8 to 10 years.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 5,
    category: 'lifestyle',
    questionText: 'Cocaine use, even recreationally on weekends, is often referred to by cardiologists as the "perfect heart attack drug" because it:',
    type: 'multi',
    answers: [`A) Causes a sudden, massive spike in blood pressure and heart rate.`, `B) Constricts the coronary arteries (the heart's own blood supply).`, 'C) Increases the risk of blood clots.', 'D) All of the above.'],
    correctAnswer: 3,
    educationText: 'Cocaine puts extreme stress on the male heart. Even in young, fit men, it can cause sudden cardiac death or a "silent" heart attack by forcing the heart to work harder while simultaneously cutting off its oxygen supply.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 6,
    category: 'lifestyle',
    questionText: 'A standard pint of 5% lager contains approximately the same amount of calories as which of the following?',
    type: 'multi',
    answers: ['A) A small apple', 'B) A glazed doughnut', 'C) A single digestive biscuit', 'D) A handful of blueberries'],
    correctAnswer: 1,
    educationText: 'Many men track food but forget "liquid calories." A pint of lager is roughly 210–250 calories. Drinking three pints is equivalent to eating two beef burgers, which contributes significantly to visceral (belly) fat—the type most linked to Type 2 Diabetes.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 7,
    category: 'lifestyle',
    questionText: 'True or False: If a man only smokes 1 to 4 cigarettes on a Saturday night, he has successfully avoided the major heart disease risks associated with smoking.',
    type: 'trueFalse',
    answers: ['True', 'False'],
    correctAnswer: 1,   /* 1 = False, 0 = True */
    educationText: 'According to the British Heart Foundation and The BMJ, smoking just one cigarette a day can carry nearly half the excess risk of heart disease and stroke as smoking a full pack of 20. There is no "safe" threshold for cardiovascular health.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 8,
    category: 'lifestyle',
    questionText: 'Smoking is a leading cause of erectile dysfunction (ED) in men because it:',
    type: 'multi',
    answers: ['A) Reduces testosterone levels instantly.', 'B) Damages the lining of blood vessels and restricts blood flow.', 'C) Causes a temporary loss of sensation.', 'D) Makes you too tired for physical activity.'],
    correctAnswer: 1,
    educationText: 'Smoking causes "vasoconstriction" and damages the delicate lining of the blood vessels (the endothelium). Because the arteries that supply an erection are much smaller than those in the heart, ED is often one of the first physical signs of smoking-related vascular damage.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 9,
    category: 'lifestyle',
    questionText: `Which type of exercise is particularly effective at reducing a man's risk of developing Type 2 Diabetes because it builds lean muscle?`,
    type: 'multi',
    answers: ['A) Long-distance jogging', 'B) Stretching and flexibility exercises', 'C) Resistance or strength training (lifting weights)', 'D) Casual walking'],
    correctAnswer: 2,
    educationText: 'Skeletal muscle acts like a "sugar sponge," absorbing up to 80% of glucose from the blood after a meal. By increasing muscle mass, men can improve their body’s insulin sensitivity, helping to prevent the onset of Type 2 Diabetes. The National Health Service (NHS) and Diabetes UK suggest that combining strength training with aerobic activity is the "gold standard" for long-term prevention.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 10,
    category: 'lifestyle',
    questionText: 'Many common Sexually Transmitted Infections (STIs), such as Chlamydia, often present with which primary symptom in men?',
    type: 'multi',
    answers: ['A) A bright red rash on the torso', 'B) Intense, constant pain', 'C) High fever and chills', 'D) No symptoms at all'],
    correctAnswer: 3,
    educationText: 'Many STIs are asymptomatic ("silent"), meaning a person can have and spread an infection without knowing it. Regular testing is the only way to confirm a clean bill of health.',
    resourceLink: '/resources/lifestyle',
  },
  {
    id: 11,
    category: 'general',
    questionText: 'Beyond preventing cavities, why is it vital for men to have at least one professional dental check-up and cleaning per year?',
    type: 'multi',
    answers: ['A) To check for early signs of oral cancer, which is twice as common in men.', 'B) Because gum disease is linked to an increased risk of heart disease and diabetes.', 'C) To remove hardened plaque (tartar) that cannot be brushed away at home.', 'D) All of the above'],
    correctAnswer: 3,
    educationText: `Systemic Link: Chronic inflammation from gum disease (periodontitis) can allow bacteria to enter the bloodstream, which is linked to heart disease and can make blood sugar harder to control for men with diabetes.
Cancer Screening: Men are statistically more likely to develop oral and throat cancers; a dentist is often the first person to spot these during a routine exam.
The "Calculus" Factor: Once plaque hardens into tartar (calculus), it acts like a "coral reef" for bacteria that regular brushing cannot remove, requiring professional tools to prevent bone loss in the jaw.`,
    resourceLink: '/resources/general',
  },
  {
    id: 12,
    category: 'general',
    questionText: 'Which of the following non-eye-related health conditions can often be detected early during a comprehensive eye examination?',
    type: 'multi',
    answers: ['A) High blood pressure (hypertension)', 'B) Diabetes', 'C) High Cholesterol', 'D) All of the above'],
    correctAnswer: 3,
    educationText: 'The eye is the only place in the body where a doctor can see blood vessels and nerves directly without surgery. By looking at the back of your eye (the retina), opticians can spot early signs of heart disease, diabetes, and even certain neurological conditions before you feel any symptoms elsewhere in your body.',
    resourceLink: '/resources/general',
  },
  {
    id: 13,
    category: 'general',
    questionText: 'According to ENT (Ear, Nose, and Throat) specialists, what is the safest way to clean the inside of your ear canal at home?',
    type: 'multi',
    answers: ['A) Using a cotton bud', 'B) Using a twisted corner of a towel', 'C) Using a specialised "ear vacuum" from the internet', 'D) Nothing - you should never put anything smaller than your elbow inside your ear'],
    correctAnswer: 3,
    educationText: 'This classic medical saying highlights that the ear is self-cleaning. Using cotton buds often pushes wax deeper against the eardrum, leading to impaction or even a perforated eardrum. If wax is a recurring issue, the NHS recommends olive oil drops to soften it naturally.',
    resourceLink: '/resources/general',
  },
  {
    id: 14,
    category: 'general',
    questionText: 'Which is the most important time of day to brush your teeth to prevent long-term damage?',
    type: 'multi',
    answers: ['A) First thing in the morning', 'B) Immediately after lunch', 'C) Last thing before bed', 'D) Right after drinking coffee'],
    correctAnswer: 2,
    educationText: `While we sleep, our mouths produce less saliva, which is the body's natural protection against decay. Brushing before bed removes the day’s buildup of plaque and food debris, ensuring bacteria don't have "fuel" to produce acids that damage enamel and irritate gums overnight. In the UK, men are significantly more likely than women to skip this crucial session.`,
    resourceLink: '/resources/general',
  },
  {
    id: 15,
    category: 'mh',
    questionText: 'In men, depression often manifests differently than in women. Which of the following is a common "masked" sign of depression in men? ',
    type: 'multi',
    answers: ['A) Increased irritability and anger', 'B) Risk-taking behaviour (e.g. reckless driving)', 'C) Escapist behaviour (e.g. overworking or excessive gaming)', 'D) All of the above'],
    correctAnswer: 3,
    educationText: `Because of social conditioning, men are often less likely to report feeling "sad." Instead, depression may show up as low frustration tolerance or "acting out." According to the NHS, men may also experience physical symptoms like headaches or digestive issues that don't respond to treatment.`,
    resourceLink: '/resources/mh',
  },
  {
    id: 16,
    category: 'mh',
    questionText: 'True or False: A man who is still going to work every day and socialising at the pub cannot be clinically depressed.',
    type: 'trueFalse', 
    answers: ['True', 'False'],
    correctAnswer: 1,
    educationText: 'Many men suffer from what is sometimes called "High-Functioning Depression." They may maintain their daily routine and "mask" their feelings in social settings while feeling completely empty or exhausted internally. In the UK, three-quarters of all suicides are men, often because they feel they must "man up" and keep their struggles hidden. ',
    resourceLink: '/resources/mh',
  },
  {
    id: 17,
    category: 'mh',
    questionText: 'Many men use "avoidance" to cope with trauma. Which of the following is a form of avoidance commonly seen in men with PTSD?',
    type: 'multi',
    answers: ['A) Staying excessively busy with work or hobbies', 'B) Using alcohol or recreational drugs to "numb" feelings', 'C) Avoiding specific places, people, or conversations related to the event', 'D) All of the above'],
    correctAnswer: 3,
    educationText: 'Avoidance is a core symptom of PTSD. Men may throw themselves into work or use substances to distract themselves from intrusive memories. While this provides temporary relief, it often exacerbates the symptoms in the long run by preventing the brain from processing the trauma.',
    resourceLink: '/resources/mh',
  },
  {
    id: 18,
    category: 'mh',
    questionText: 'How can childhood trauma "mimic" neurodivergent traits like ADHD in adult men?',
    type: 'multi',
    answers: ['A) Always scanning for danger (hypervigilance) can look like a lack of focus', 'B) Feeling "on edge" can look like physical hyperactivity or restlessness', 'C) Difficulty regulating big emotions can look like ADHD impulsivity', 'D) All of he above'],
    correctAnswer: 3,
    educationText: 'Trauma can "rewire" the brain in ways that mirror neurodivergence. For example, a man who is constantly scanning his environment for threats (hypervigilance) may appear inattentive or distractible, common traits of ADHD. This is why trauma-informed assessments are so important for getting the right support.',
    resourceLink: '/resources/mh',
  },
  {
    id: 19,
    category: 'mh',
    questionText: 'What is the leading cause of death for men under the age of 50 in the UK?',
    type: 'multi',
    answers: ['A) Heart Disease', 'B) Road accidents', 'C) Suicide', 'D) Cancer'],
    correctAnswer: 2,
    educationText: `Suicide remains the single leading cause of death for UK men aged 20-49. In 2024, the male suicide rate was roughly three times higher than the female rate, with men accounting for about 75% of all UK suicides.`,
    resourceLink: '/resources/mh',
  },
  {
    id: 20,
    category: 'cancer',
    questionText: 'In adult men aged 15 to 44 in England, which of the following is the most commonly diagnosed type of cancer?',
    type: 'multi',
    answers: ['A) Prostate Cancer', 'B) Lung Cancer', 'C) Testicular Cancer', 'D) Bowel Cancer'],
    correctAnswer: 2,
    educationText: `While prostate cancer is the most common for men over 45, testicular cancer is the most frequent diagnosis for men aged 15 to 44. In the UK, around 2,300 men are diagnosed with it annually. It is often called a "young man's disease" because incidence rates are highest in those aged 30 to 34.`,
    resourceLink: '/resources/cancer',
  },
  {
    id: 21,
    category: 'cancer',
    questionText: 'In the UK, what is the single most common cancer diagnosed in men over the age of 45?',
    type: 'multi',
    answers: ['A) Lung Cancer', 'B) Prostate Cancer', 'C) Skin Cancer', 'D) Bowel Cancer'],
    correctAnswer: 1,
    educationText: 'Prostate cancer is the most common cancer in men in the UK, with 1 in 8 men being diagnosed in their lifetime. While it is rare in men under 45, the risk rises significantly as you age, with most cases diagnosed in men aged 65 and over.',
    resourceLink: '/resources/cancer',
  },
  {
    id: 22,
    category: 'cancer',
    questionText: 'Health organisations like the NHS and Testicular Cancer UK suggest a specific frequency for men to check their testicles for lumps or changes. What is the recommended routine?',
    type: 'multi',
    answers: ['A) Only when you feel a sharp or sudden pain.', 'B) Once every year during a GP check-up.', 'C) Once a month, ideally during or after a warm bath or shower.', 'D) Every morning as part of a daily grooming routine.'],
    correctAnswer: 2,
    educationText: 'The reason experts recommend checking monthly is to help you "know your normal." By spending just a few seconds once a month, you become familiar with the usual size and weight of your testicles. This makes it much easier to notice a new, pea-sized lump or an unusual heaviness. A warm shower is the best time because the heat relaxes the scrotum, making it much easier to feel for changes. If you do find a lump, remember that most are not cancer, but because testicular cancer is highly curable when caught early, you should always get any changes checked by a GP.',
    resourceLink: '/resources/cancer',
  },
  {
    id: 23,
    category: 'cancer',
    questionText: 'True or False: A PSA (Prostate-Specific Antigen) blood test alone can confirm that a man definitely has prostate cancer.',
    type: 'trueFalse',
    answers: ['True', 'False'],
    correctAnswer: 1,
    educationText: `The PSA test measures a protein produced by the prostate, but it is not a "yes or no" test for cancer. A high PSA level can be caused by many non-cancerous things, such as an enlarged prostate (BPH), a urinary infection, or even recent vigorous exercise. According to Prostate Cancer UK, the test is a "risk indicator." If your levels are high, your GP will usually suggest further steps, like an MRI scan or a biopsy, to get a definitive answer. In the UK, any man over 50 (or 45 if at higher risk) can request a PSA test after discussing the pros and cons with their doctor.`,
    resourceLink: '/resources/cancer',
  },
  {
    id: 24,
    category: 'cancer',
    questionText: `In the UK, the NHS sends out a bowel cancer screening kit (called a FIT kit) to eligible men. How often is this screening usually repeated?
`,
    type: 'multi',
    answers: ['A) Once a year', 'B) Once every 2 years', 'C) Once every 5 years', 'D) Only once in your lifetime'],
    correctAnswer: 1,
    educationText: `Across the UK, the NHS bowel cancer screening programme aims to detect cancer at an early stage when treatment is most effective. In England, Scotland, and Wales, the FIT kit is automatically sent every two years to people aged 50 to 74. The kit is a simple home test used to find tiny amounts of blood in your poo that aren't visible to the naked eye. Regular screening is vital because it can also find and remove polyps (small growths) before they have a chance to turn into cancer.`, 
    resourceLink: '/resources/cancer',
  },
  {
    id: 25,
    category: 'cancer',
    questionText: 'True or False: The NHS has a national screening programme that proactively invites certain people for "Lung Health Checks," even if they have no symptoms.',
    type: 'trueFalse',
    answers: ['True', 'False'],
    correctAnswer: 0,
    educationText: 'The NHS Lung Cancer Screening Programme is a proactive service currently being rolled out across the UK. Unlike other screenings that are open to everyone in an age group, this is a targeted programme. It is designed for people aged 55 to 74 who are current or former smokers, as they are at the highest risk. The goal is to catch lung cancer at the "early stage" before symptoms appear, which significantly increases the chances of successful treatment.',
    resourceLink: '/resources/cancer',
  },
  {
    id: 26,
    category: 'general',
    questionText: `True or False: The NHS provides a free screening programme specifically for men to check for a swelling in the main blood vessel of the tummy (an Abdominal Aortic Aneurysm). `,
    type: 'trueFalse',
    answers: ['True', 'False'],
    correctAnswer: 0,
    educationText: `The NHS Abdominal Aortic Aneurysm (AAA) screening programme is a free service offered to all men during the year they turn 65. It involves a quick, painless ultrasound scan of the abdomen to check the width of the aorta, the main blood vessel that runs from the heart down to the tummy. Men are six times more likely to have an aneurysm than women, which is why the programme specifically invites men. Because aneurysms usually have no symptoms, screening is the only way to find them before they potentially burst, which can be life-threatening. If you are a man over 65 and have never been screened, you can self-refer by contacting your local AAA screening service directly.`,
    resourceLink: '/resources/general',
  },
  {
    id: 27,
    category: 'general',
    questionText: 'Which of the following NHS screening programmes may still be relevant for trans men?',
    type: 'multi',
    answers: ['A) Breast screening', 'B) Cervial screening', 'C) Abdominal Aortic Aneurysm (AAA) screening', 'D) All of the above'],
    correctAnswer: 3,
    educationText: `Trans men’s screening needs depend on both their anatomy and their GP registration. If a trans man has a cervix or breast tissue, they are still at risk for those cancers and should be screened.`,
    resourceLink: '/resources/general',
  },
  {
    id: 28,
    category: 'cancer',
    questionText: `In the UK, men are significantly more likely to die from skin cancer (melanoma) than women. Where on the body do these cancers most commonly develop in men?`,
    type: 'multi',
    answers: ['A) On the legs and feet', 'B) One the face and neck', 'C) On the back and torso', 'D) On the palms and hands'],
    correctAnswer: 2,
    educationText: `Men are more likely to develop melanomas on their chest and back, often due to sun exposure while gardening, working outdoors, or playing sports shirtless. Because the back is difficult to see, these moles often go unnoticed until they are at an advanced stage. According to Cancer Research UK, men have a higher mortality rate from skin cancer partly because they are less likely to perform regular skin checks or ask for help. It is vital to use the "partner check" or a mirror to inspect your back once a month. `,
    resourceLink: '/resources/cancer',
  },
  {
    id: 29,
    category: 'cardiovascular',
    questionText: 'True or False: Ischaemic heart disease (coronary heart disease) remains the leading cause of death for men in England and Wales.',
    type: 'trueFalse',
    answers: ['True', 'False'],
    correctAnswer: 0,
    educationText: `According to the latest ONS data for 2024, Ischaemic heart disease is the single biggest killer of men, accounting for 12.5% of all male deaths. In contrast, the leading cause of death for women is Dementia and Alzheimer's disease, which accounts for 15.6% of all female deaths. While dementia is the leading cause for the UK population as a whole, heart disease continues to claim more men's lives annually—over 41,000 deaths in 2024 compared to roughly 28,000 for dementia in the same group.`,
    resourceLink: '/resources/cardiovascular',
  },
  {
    id: 30,
    category: 'cardiovascular',
    questionText: 'If you suspect you or someone else is having a heart attack—even if the symptoms seem mild—what is the first and most important action you should take?',
    type: 'multi',
    answers: ['A) Drive yourself to the nearest hospital', 'B) Call 999 immediately', 'C) Take an aspirin and wait for the pain to pass', 'D) Call your GP surgery for advice'],
    correctAnswer: 1,
    educationText: 'A heart attack is a medical emergency. According to the NHS, you should call 999 immediately if you experience symptoms like a sensation of pressure or squeezing in the chest, pain that spreads to the arms, neck, or jaw, or feeling lightheaded and sweaty.',
    resourceLink: '/resources/cardiovascular',
  },
  {
    id: 31, 
    category: 'cardiovascular',
    questionText: `The NHS uses the word 'FAST' to help people remember the signs of a stroke and what to do. What is the correct action to take the moment you notice any one of these signs?`,
    type: 'multi',
    answers: ['A) Book an emergency appointment with your GP', 'B) Call 999 immediately', 'C) Wait for an hour to see if the symptoms go away', 'D) Drive the person to a walk-in centre'],
    correctAnswer: 1,
    educationText: `A stroke is a "brain attack" caused by a cut-off in blood supply. Using the FAST test can help you save a life:
\nFace: Has their face fallen on one side? Can they smile?
\nArms: Can they raise both arms and keep them there?
\nSpeech: Is their speech slurred or garbled?
\nTime: It is time to call 999 immediately if you see any of these signs.`,
    resourceLink: '/resources/cardiovascular',
  },
  {
    id: 32, 
    category: 'cardiovascular',
    questionText: `High blood pressure (Hypertension) rarely has noticeable symptoms, but it significantly increases the risk of heart attacks and strokes. Which of the following factors can increase your risk of developing high blood pressure?`,
    type: 'multi',
    answers: [`A) Lifestyle factors (e.g. high salt diet, smoking, and excessive alcohol)`, `B) Biological factors (e.g. getting older or having close relatives with it)`, `C) Environmental factors (e.g. being overweight or long-term stress)`, `D) All of the above`],
    correctAnswer: 3,
    educationText: `High blood pressure is often called the "silent killer" because you can feel perfectly fine while it is damaging your arteries. According to the NHS, your risk increases due to:
\nAge: Your risk grows as you get older.
\nGenes: Having close relatives with high blood pressure.
\nEthnicity: People of Black African or Black Caribbean descent are at higher risk.
\nDiet & Habits: A diet high in salt, being overweight, smoking, or drinking too much alcohol.
\nStress: Being stressed over a long period of time.`,
    resourceLink: '/resources/cardiovascular',
  },
  {
    id: 33, 
    category: 'cardiovascular',
    questionText: `Men are statistically more likely to have high cholesterol than women, which can lead to clogged arteries. What is the most common type of medication prescribed by the NHS to help lower cholesterol levels?`,
    type: 'multi',
    answers: ['A) Antibiotics', 'B) Statins', 'C) Antivirals', `D) Beta-blocers`],
    correctAnswer: 1,
    educationText: 'High cholesterol is a major risk factor for heart disease and stroke. According to the NHS, Statins are the most common medicine used to lower cholesterol. They work by reducing the amount of cholesterol made by your liver.',
    resourceLink: '/resources/cardiovascular',
  },

  ]